<template>
  <div class="page">
    <div v-if="model != null">
      <van-panel class="panel-info">
        <div class="content">
          <div class="row" style="margin-top: 0">
            <van-cell class="cell-padding" size="large" center >
              <div class="clerk-item">
                <div class="left align-center">
                  <div class="clerk-head">
                    <van-image round width="70px" height="70px" :src="model.avatarUrl"></van-image>
                  </div>
                  <div class="padding-left-sm">
                    <!-- id -->
                    <div class="left-sm-tag">
                      <van-tag plain type="primary">ID：{{ model.clerkId }}</van-tag>
                    </div>
                    <!-- 店员昵称 -->
                    <div>
                      <span>{{ model.name }}</span>
                    </div>
                  </div>
                </div>
                <div class="right">
                </div>
              </div>
            </van-cell>
          </div>
          <!-- 店员微信号 -->
          <div v-if="model.wechat" class="row">
            <span class="label">微信号</span>
            <span class="value">{{ model.wechat }}</span>
            <button
                v-clipboard="copyWechat"
                class="van-button van-button--primary van-button--small"
                style="height: 20px; line-height: 18px"
                @error="copyCallback(false)"
                @success="copyCallback(true)"
            >
              复制微信
            </button>
          </div>
          <div class="row">
            <span class="label">订单号</span>
            <span class="value">{{ model.no }}</span>
          </div>
          <div class="row">
            <span class="label">订单内容</span>
            <div v-if="model.type === 'course'">{{model.detail.itemName + '-' + model.detail.name}}</div>
            <span class="value" v-else>{{(model.userId ? '赠送' : '') + model.detail.itemName + '-' + model.detail.dayNum + '天'}}</span>
          </div>
          <div class="row">
            <span class="label">订单状态</span>
            <van-tag v-if="model.status == 0" plain type="warning">待付款</van-tag>
            <van-tag v-if="model.status == 1" plain type="primary">已付款</van-tag>
            <van-tag v-if="model.status == 2" plain type="success">已完成</van-tag>
          </div>
          <div class="row">
            <span class="label">下单时间</span>
            <span class="value">{{formatDate(model.createTime, "YYYY-MM-DD HH:mm:ss") }}</span>
          </div>
          <div class="row" v-if="model.finishTime">
            <span class="label">结束时间</span>
            <span class="value">{{formatDate(model.finishTime, "YYYY-MM-DD HH:mm:ss") }}</span>
          </div>
          <div class="row">
            <span class="label">订单金额</span
            ><span class="value">￥{{ formatPrice(model.payAmount) }}</span>
          </div>
        </div>
        </van-panel>
      <!-- 完成订单 -->
      <div align="center" style="padding: 0 10px;">
        <van-button type="info" size="large" v-if="model.status === 1"
                    @click="finishOrder">待完成</van-button>
        <van-button type="primary" size="large" v-else-if="model.status === 2">已完成</van-button>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import {
  Button,
  Cell, CellGroup,
  Dialog,
  Field,
  Icon,
  Panel,
  Tag,
  Image,
  Toast, Uploader,
} from "vant";
import Decimal from "decimal.js";
import moment from "moment";
import VueClipboards from "vue-clipboards";
import { getOrder, finishedOrder } from "@/api/kf/clerk-order"


Vue.use(Panel)
  .use(Cell)
  .use(CellGroup)
  .use(Button)
  .use(Tag)
  .use(Icon)
  .use(Toast)
  .use(Dialog)
  .use(Uploader)
  .use(Image)
  .use(Field);

Vue.use(VueClipboards);

export default {
  name: "clerk-order-detail",
  components: {
  },

  data() {
    return {
      showViolation: false,
      fileList: [],
      continuedApplyFileList: [],
      ORDER: this.$store.state.order,
      UserInfoEnum: this.$store.state.UserInfoEnum,
      show: false,
      value: "",
      model: null,
      sign: null,
      btnConfirmDisabled: true,
      confirmCountDown: 3,
      cancelCountDown: null,
      canClerkCancelOrder: null,
      showOrderContinuedApplyDialog: false,
      orderContinuedApplyMessage: null,
      isVerify: false,
      canClerkCancelOrderUploadWaitService: false,
      clerkContinuedApplyUpload: false,
      remindUserContinued: false,
    };
  },
  computed: {
    copyWechat() {
      if (this.model) {
        return this.model.wechat;
      }
      return null;
    },
  },
  methods: {
    formatDate(date, format) {
      if (!date) {
        return "";
      }
      if (!format) {
        format = "YYYY-MM-DD";
      }
      return moment(date).format(format);
    },
    formatPrice(price) {
      if (price != null) {
        return Decimal.div(price, 100).toString();
      }
      return "";
    },
    copyCallback(success) {
      if (success) {
        Toast("复制成功");
      } else {
        Toast("复制失败，请长按文本复制");
      }
    },
    loadData() {
      Toast.loading({
        mask: true,
        message: "加载中...",
      });
      getOrder(this.$route.params.id).then((res) => {
        Toast.clear();
        const data = res.data;
        if (data.code == 0) {
          this.model = data.clerkOrder;
        } else {
          Dialog.alert({
            title: "加载失败",
            message: data.msg,
          });
        }
      });
    },
    finishOrder() {
      Toast.loading({
        mask: true,
        message: "处理中...",
      });
      // 处理订单
      finishedOrder(
          this.model.id
      ).then(res => {
        Toast.clear();
        const data = res.data
        if (data.code == 0) {
          Toast("处理成功");
          this.loadData()
        } else {
          Dialog.alert({
            title: '处理失败',
            message: data.msg
          })
        }
      })
    },
  },
  mounted() {
    this.loadData();
  }
};
</script>

<style lang="less" scoped>
.page {
  padding-bottom: 100px;
  .van-panel__header{
    padding:0;
  }
  .panel-info {

    .content {
      font-size: 14px;
      padding: 30px 15px 15px;

      .row {
        .cell-padding{
          padding: 0;
          .clerk-item {
            display: flex;
            align-items: center;
            .userMemo {
              color: #999;
            }
            .left {
              flex: 1;
              display: flex;
              .service-info {
                color: #333;
              }
              .created {
                color: #555;
                margin-bottom: 5px;
              }
              .clerk-head {
                position: relative;
                padding: 10px;
                .avatarFrame {
                  position: absolute;
                  top: 0;
                  left: 0;
                }
                .level {
                  position: absolute;
                  left: 50%;
                  height: 10px;
                  font-size: 10px;
                  white-space: nowrap;
                  bottom: 0px;
                  transform: translateX(-50%);
                }
              }
              .padding-left-sm div span{
                margin-right: 4px;
              }
            }
            .right {
              text-align: right;
              min-width: 30px;
              .total-amount {
                color: #333;
              }
            }
          }
        }
      }
    }
  }

  .row {
    display: flex;
    color: #333;
    margin: 10px 0;
    align-items: center;
  }

  .label {
    width: 80px;
    color: #888;
  }

  .value {
    flex: 1;
  }

  .bottom-bar {
    padding: 10px 15px;
    /*background: #fff;*/
    /*box-shadow: 0 0 3px 0px #333;*/
    /*position: fixed;*/
    /*bottom: 0;*/
    /*left: 0;*/
    /*right: 0;*/
  }

  .commentBox {
    width: 100%;
    background: #fff;
    padding: 15px;
    margin-top: 20px;
    box-sizing: border-box;
  }

  .imgStyle {
    margin-left: 10px;
    flex: 0 0 15%;
    height: 0;
    padding-bottom: 15%;
    overflow: hidden;
    position: relative;
  }

  .screenshot {
    width: 100%;
    display: flex;
    align-content: flex-start;
    flex-flow: row wrap;
  }

  .screenshotImg {
    width: 100%;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }

  .module {
    margin-top: 15px;
    padding: 0px 15px;
    position: relative;

    /deep/ .van-cell {
      padding: 15px 0;
      background: transparent;
      font-size: 14px;
      line-height: 20px;
      font-family: PingFangSC-Regular, PingFang SC;

      &.module-title {
        padding-bottom: 0;
      }

      .van-cell__title {
        width: 90px;
        flex: none;
        box-sizing: border-box;
        font-weight: 600;
        color: #333333;
      }

      .van-cell__value {
        font-weight: 400;
        color: #999999;
      }

      &.van-cell--required {
        &::before {
          left: 0px;
        }
      }
    }
  }

  .image-uploader {
    /deep/ .van-uploader__wrapper {
      .van-uploader__preview {
        .van-uploader__preview-delete {
          top: 0;
          right: 0;
          color: var(--primary-color);
        }
      }
    }
  }

}
</style>
